import {
  registerDecorator,
  type ValidationOptions,
  type ValidationArguments,
} from 'class-validator';
import { parseVideoUrl } from '@builder4/shared/utils/videoHelpers';

/**
 * Validates that a value is either empty or a valid video URL.
 * Uses parseVideoUrl from videoHelpers to validate against supported providers.
 */
export function IsVideoUrl(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isVideoUrl',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          if (typeof value !== 'string') {
            return false;
          }
          // Empty string is valid (means no video URL set)
          if (!value.trim()) {
            return true;
          }
          const parsed = parseVideoUrl(value);
          return parsed.isValid;
        },
        defaultMessage(args: ValidationArguments) {
          return `${args.property} must be a valid video URL from a supported provider (YouTube, Vimeo, Loom, Wistia, Vidyard, Brightcove, or Cloudflare Stream)`;
        },
      },
    });
  };
}
